/**
 * Core domain enums for Stage Door Access
 * These map directly to PostgreSQL enums in the database
 */
export const UserRole = {
    STUDIO: 'studio',
    FACULTY: 'faculty',
    ADMIN: 'admin',
};
// Mirrors the DB enum `booking_status` exactly (pg_enum order):
// pending, deposit_paid, confirmed, balance_paid, completed, cancelled, refunded.
// NOTE: there is NO 'balance_due' or 'paid_in_full' booking_status — the "balance
// is due / fully paid" nuance lives in the separate `balance_status` column.
// Sending a non-enum value to PostgREST 400s (see admin.ts:3085-3103 warnings).
export const BookingStatus = {
    PENDING: 'pending',
    DEPOSIT_PAID: 'deposit_paid',
    CONFIRMED: 'confirmed',
    BALANCE_PAID: 'balance_paid',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
    REFUNDED: 'refunded',
};
/** Admin "Active" bookings view: money down & upcoming. Excludes pending (unpaid),
 *  completed, cancelled, refunded. All three are real `booking_status` enum values.
 *  Distinct from campaign BOOKED_STATUSES. */
export const ACTIVE_BOOKING_STATUSES = [
    BookingStatus.DEPOSIT_PAID,
    BookingStatus.CONFIRMED,
    BookingStatus.BALANCE_PAID,
];
// Must mirror the DB enum `class_status` exactly
// (supabase/migrations/20250124000001_core_entities.sql) — PostgREST rejects
// any value outside the DB enum with a 400. 'confirmed' is a BOOKING status
// (see BookingStatus above), never a class status; the drift here caused a
// production-breaking filter swap that had to be reverted (SDA-243 f/u).
export const ClassStatus = {
    SCHEDULED: 'scheduled',
    FACULTY_ASSIGNED: 'faculty_assigned',
    READY: 'ready',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
};
export const BalanceStatus = {
    NOT_DUE: 'not_due',
    DUE: 'due',
    REMINDER_SENT: 'reminder_sent',
    OVERDUE: 'overdue',
    PAID: 'paid',
    WAIVED: 'waived',
};
export const FacultyStatus = {
    INVITED: 'invited',
    ONBOARDING: 'onboarding',
    PENDING_APPROVAL: 'pending_approval',
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    SUSPENDED: 'suspended',
};
export const PricingTier = {
    STANDARD: 'standard',
    TIER_1: 'tier_1',
    TIER_2: 'tier_2',
    DUAL_OPTION: 'dual_option',
    HOSTED: 'hosted',
};
export const CampaignType = {
    ANNOUNCEMENT: 'announcement',
    REMINDER: 'reminder',
    PROMOTION: 'promotion',
    FOLLOWUP: 'followup',
};
export const InquiryStatus = {
    PENDING: 'pending',
    IN_REVIEW: 'in_review',
    RESPONDED: 'responded',
    CONVERTED: 'converted',
    CLOSED: 'closed',
};
export const InquirySource = {
    DUAL_OPTION_HOSTED: 'dual_option_hosted',
    REMOTE_REQUEST: 'remote_request',
    GENERAL: 'general',
};
export const PaymentType = {
    DEPOSIT: 'deposit',
    BALANCE: 'balance',
    FULL: 'full',
    REFUND: 'refund',
};
export const TimeSlot = {
    MORNING: 'morning',
    AFTERNOON: 'afternoon',
    EVENING: 'evening',
};
//# sourceMappingURL=enums.js.map